import { BaseDto } from './base.dto';
import { EntityTypeDto } from './entityType.dto';
export class PrintEntityFilteringOptionDto extends BaseDto{

    entityType: EntityTypeDto;


    name: string;


    propertyPath: string[];
    

    propertyValueType: string;
}